import {IFormFilterModel} from '../models/IFormFilterModel';
import * as FormFilterActions from '../actions/FormFilterActions';
import {createFeatureSelector, createReducer, createSelector, on} from '@ngrx/store';

const initialState: IFormFilterModel = {
  year: {year: 0},
  state: null,
  county: null,
  crop: {Code: '', Id: 0, Name: '', CommodityCode: ''},
  plan: {Id: 0, Name: ''}
};

export const reducer = createReducer(
  initialState,
  on(FormFilterActions.UpdateYearAction, (formState, {year}) => ({
      ...formState, year
    })
  ),
  on(FormFilterActions.UpdateCommodityAction, (formState, {commodity}) => ({
      ...formState, crop: commodity
    })
  ),
  on(FormFilterActions.UpdateStateAction, (formState, {state}) => ({
      ...formState, state
    })
  ),
  on(FormFilterActions.UpdateCountyAction, (formState, {county}) => ({
      ...formState, county
    })
  )
);

export const featureSelector = createFeatureSelector<IFormFilterModel>('formFilterSelections');

export const getCurrentSetYear = createSelector(
  featureSelector,
  state => state.year
);

export const getSelectedState = createSelector(
  featureSelector,
  state => state.state
);

export const getSelectedCounty = createSelector(
  featureSelector,
  state => state.county
);

export const getSelectedCrop = createSelector(
  featureSelector,
  state => state.crop
);
